import { addFilters, selectFilters, selectFiltersStatus, selectFiltersTypes, selectLocation, updateLocation } from '../menu/filtersSlice'
import { fetchCategories, selectCategories, selectCategoriesStatus } from '../../Categories/categoriesSlice'
import { resetMapOptions, selectMapOptions, updateMapOption } from '../Map/mapSlice'
import { useSelector, useDispatch } from 'react-redux'
import LocationSelect from 'components/LocationSelect'
import useTranslation from 'hooks/useTranslation'
import { DISTANCE_LIST } from '../Map/mapUtils'
import Select from 'components/inputs/Select'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useEffect, useState } from 'react'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import Error from 'components/Error'
import Range from 'components/Range'

const FilterPopup = () => {
  const location = useSelector(selectLocation)
  const categories = useSelector(selectCategories)
  const selectedFilters = useSelector(selectFilters)
  const filtersTypes = useSelector(selectFiltersTypes)
  const filtersStatus = useSelector(selectFiltersStatus)
  const categoriesStatus = useSelector(selectCategoriesStatus)
  const { distance, voivodship } = useSelector(selectMapOptions)
  const [filters, setFilters] = useState(selectedFilters)

  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const { t } = useTranslation('filters')

  const updateFilter = (name, where, value = '', additionalName = '', f = filters) => {
    const newVal = additionalName ? { ...f[where][name], [additionalName]: value } : value

    if (value !== '') setFilters({ ...f, [where]: { ...f[where], [name]: newVal } })
    else {
      const copy = { ...f[where] }

      if (additionalName) {
        delete copy[name][additionalName]
        if (Object.keys(copy[name]).length === 0) delete copy[name]

      } else delete copy[name]
      setFilters({ ...f, [where]: copy })
    }
  }

  const saveFilters = value => {
    dispatch(addFilters(value))
    goBack()
  }

  useEffect(() => {
    if (categoriesStatus !== STATUS.succeed) dispatch(fetchCategories())
  }, [categoriesStatus, dispatch])

  return (
    <Popup isLine={false}>
      <div className='popup--filter'>
        <h2>{t('selectFilters')}</h2>

        {filtersStatus === STATUS.failed || categoriesStatus === STATUS.failed ? <Error staticPos />
          : filtersStatus === STATUS.succeed && categoriesStatus === STATUS.succeed ? <div className='popup__main'>
            <div className='popup__list'>
              {Object.entries(filtersTypes).map(([, { name, where, field, type, options }], idx) => {
                let filter = false

                if (field === 'categoryId') {
                  filter = <>
                    <Select
                      value={filters[where][field] || ''}
                      options={[
                        { value: '', name: t('all') },
                        ...categories.reduce((r, { disabled, name, id }) => {
                          if (!disabled) r.push({ value: id, name })
                          return r
                        }, [])
                      ]}
                      setValue={value => {
                        if (filters[where]['warehouseTypeId']) {
                          const copy = { ...filters[where] }
                          delete copy['warehouseTypeId']
                          updateFilter(field, where, value, '', { ...filters, [where]: copy })
                        } else {
                          updateFilter(field, where, value)
                        }
                      }}
                    />

                    {filters[where][field] && ((value) => {
                      const categoriesList = categories.find(({ id }) => id === value)?.warehouseTypes?.map(({ typeNameForClient, id }) => ({ name: typeNameForClient, value: id }))
                      return categoriesList
                        ? <div className='element'>
                          <div className='element__title'>{t('size')}</div>
                          <Select
                            value={filters[where]['warehouseTypeId'] || ''}
                            options={categoriesList
                              ? [
                                { value: '', name: t('all') },
                                ...categoriesList
                              ] : [
                                { value: '', name: t('all') },
                              ]
                            }
                            setValue={value => {
                              updateFilter('warehouseTypeId', where, value)
                            }}
                          />
                        </div>
                        : null
                    })(filters[where][field])}
                  </>

                } else if (field === 'area') {
                  filter = <Range
                    unit={<>m<sup>2</sup></>}
                    value={[filters[where][field]?.min, filters[where][field]?.max]}
                    options={[0, 1, 5, 10, 14, 30, 56]}
                    updateValue={d => {

                      const copy = { ...filters[where][field] }
                      if (filters[where][field]?.min !== d[0]) copy.min = d[0]
                      if (filters[where][field]?.max !== d[1]) copy.max = d[1]

                      setFilters(f => { return { ...f, [where]: { ...f[where], [field]: copy } } })
                    }}
                  />

                } else if (type === 'range') {
                  filter = <div className='group'>
                    <input
                      placeholder={t('from')}
                      type='number'
                      value={filters[where][field]?.min || ''}
                      onChange={e => updateFilter(field, where, e.target.valueAsNumber || '', 'min')} />

                    <input
                      placeholder={t('to')}
                      type='number'
                      value={filters[where][field]?.max || ''}
                      onChange={e => updateFilter(field, where, e.target.valueAsNumber || '', 'max')} />
                  </div>

                } else if (type === 'location') {
                  filter = <LocationSelect
                    secondaryTheme
                    label={false}
                    address={location}
                    voivodship={voivodship}
                    clearAddress={() => {
                      dispatch(resetMapOptions())
                      dispatch(updateLocation(''))
                    }}
                    setAddress={(address, mapOption) => {
                      dispatch(updateLocation(address))
                      dispatch(updateMapOption(mapOption))
                    }}
                  />

                } else if (type === 'distance') {
                  filter = <Select
                    value={distance || DISTANCE_LIST[0]}
                    options={DISTANCE_LIST.map(value => ({ value, name: `${value} km` }))}
                    setValue={value => {
                      dispatch(updateMapOption({ distance: value }))
                    }}
                  />

                } else if (type === 'select') {
                  filter = <Select
                    secondaryTheme
                    value={filters[where][field] || ''}
                    options={options}
                    setValue={value => {
                      const newVal = value === 'true' ? true : value
                      updateFilter(field, where, newVal)
                    }}
                  />

                } else if (type === 'section') {
                  filter = <div className='element__section'>
                    {options.map(({ type, field, where, value, name }, idx) => <div
                      key={idx}
                      className='element__checkbox'>
                      <input
                        id={name}
                        type='checkbox'
                        checked={type === 'array_checkbox' ? filters[where][field]?.includes(value) || false : filters[where][field] || false}
                        onChange={e => {
                          const { checked } = e.target

                          if (type === 'array_checkbox') {
                            let copy = Array.isArray(filters[where][field]) ? [...filters[where][field]] : []
                            if (checked) copy.push(value)
                            else copy = copy.filter(v => v !== value)
                            updateFilter(field, where, copy.length === 0 ? '' : copy)

                          } else updateFilter(field, where, checked || '')
                        }} />
                      <label htmlFor={name}>{name}</label>
                    </div>)}
                  </div>

                } else if (type === 'checkbox') {
                  filter = <div className='element__checkbox'>
                    <input
                      id={field}
                      type='checkbox'
                      checked={filters[where][field] || false}
                      onChange={e => updateFilter(field, where, e.target.checked || '')} />
                    <label htmlFor={field}>{name}</label>
                  </div>
                }

                return <div
                  key={idx}
                  className='element'
                  style={type === 'location' ? { width: '65%', display: 'inline-block' }
                    : type === 'distance' ? { width: '30%', marginLeft: '5%', display: 'inline-block' } : {}}>
                  {type !== 'checkbox' && <div className='element__title'>{name}</div>}
                  {filter}
                </div>
              })}
            </div>

            <div className='popup__buttons center'>
              <div
                className='button__cancel'
                onClick={() => saveFilters({})}>{t('removeFilters')}</div>
              <div
                className='button__add'
                onClick={() => saveFilters(filters)}>{t('saveChanges')}</div>
            </div>
          </div> : <Loading />}
      </div>
    </Popup>
  )
}

export default FilterPopup